'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024110 from "./presto.types$-Rule-Name$$anon$110.js";
import * as $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024111 from "./presto.types$-Rule-Name$$anon$111.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RuleName$() {
  this.caL = null;
  this.caM = false;
  this.caP = null;
  this.caQ = false;
  this.caN = null;
  this.caO = false;
  this.caR = null;
  this.caS = false;
}
export { $c_Lpresto_types$RuleName$ as $c_Lpresto_types$RuleName$ };
$p = $c_Lpresto_types$RuleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RuleName$;
/** @constructor */
function $h_Lpresto_types$RuleName$() {
}
export { $h_Lpresto_types$RuleName$ as $h_Lpresto_types$RuleName$ };
$h_Lpresto_types$RuleName$.prototype = $p;
$p.cIe = (function() {
  if ((!this.caM)) {
    this.caL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.caM = true;
  }
  return this.caL;
});
$p.csj = (function() {
  if ((!this.caQ)) {
    this.caP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.caQ = true;
  }
  return this.caP;
});
$p.csd = (function() {
  if ((!this.caO)) {
    this.caN = new $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024110.$c_Lpresto_types$RuleName$$anon$110(this);
    this.caO = true;
  }
  return this.caN;
});
$p.adK = (function() {
  if ((!this.caS)) {
    this.caR = new $j_presto$002etypes$0024$002dRule$002dName$0024$0024anon$0024111.$c_Lpresto_types$RuleName$$anon$111(this);
    this.caS = true;
  }
  return this.caR;
});
var $d_Lpresto_types$RuleName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RuleName$, "presto.types$RuleName$", ({
  a1n: 1,
  D: 1
}));
export { $d_Lpresto_types$RuleName$ as $d_Lpresto_types$RuleName$ };
var $n_Lpresto_types$RuleName$;
function $m_Lpresto_types$RuleName$() {
  if ((!$n_Lpresto_types$RuleName$)) {
    $n_Lpresto_types$RuleName$ = new $c_Lpresto_types$RuleName$();
  }
  return $n_Lpresto_types$RuleName$;
}
export { $m_Lpresto_types$RuleName$ as $m_Lpresto_types$RuleName$ };
//# sourceMappingURL=presto.types$-Rule-Name$.js.map
